import { render, staticRenderFns } from "./FoodTastes.vue?vue&type=template&id=99ef9880&"
import script from "./FoodTastes.vue?vue&type=script&lang=js&"
export * from "./FoodTastes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports